import { MOCK_ADDRESS } from './MockAddress'
import { MOCK_CONTACT } from './MockContact'

export const MOCK_CONTRACTS = [
  {
    _created_at: '2025-04-22T09:01:25.405Z',
    _id: '8b37a04c-ac8a-4598-abcc-dc4fe2634a58',
    _org: 'test-org',
    _schema: 'contract',
    _tags: ['dont-touch'],
    _title: 'Classic Green+',
    _updated_at: '2025-06-04T09:27:42.421Z',
    account_number: 'A123456789',
    amount_subtotal: 1092,
    amount_tax: 208,
    amount_total: 1300,
    balance: 0,
    balance_currency: 'EUR',
    balance_decimal: '0.00',
    billing_address: [MOCK_ADDRESS],
    billing_duration_amount: null,
    billing_duration_unit: 'months',
    billing_due_day: '1',
    billing_period: 'monthly',
    branch: 'power',
    contract_name: 'Classic Green+',
    contract_number: '589010219',
    currency: 'EUR',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    end_date: null,
    installment_amount: 7000,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '70',
    move_in_date: '2025-01-01',
    notice_time_amount: '2',
    notice_time_unit: 'months',
    renewal_duration_unit: 'months',
    start_date: '2025-01-01',
    status: 'active',
    termination_time_unit: 'months',
    type: 'recurring'
  },
  {
    _created_at: '2025-05-07T07:58:32.296Z',
    _id: '78d3639c-ef63-4517-9942-3407dda87de7',
    _org: 'test-org',
    _schema: 'contract',
    _tags: ['dont-touch'],
    _title: 'Dynamic Green+',
    _updated_at: '2025-05-23T06:27:27.846Z',
    account_number: 'B123456789',
    amount_subtotal: 0,
    amount_tax: 0,
    amount_total: 0,
    balance: 0,
    balance_currency: 'EUR',
    balance_decimal: '0.00',
    billing_address: [MOCK_ADDRESS],
    billing_duration_unit: 'months',
    billing_period: 'monthly',
    branch: 'gas',
    contract_name: 'Dynamic Green+',
    contract_number: '589010218',
    currency: 'EUR',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    end_date: null,
    installment_amount: 20000,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '200.00',
    move_in_date: '2025-05-01',
    notice_time_amount: '2',
    notice_time_unit: 'months',
    renewal_duration_unit: 'months',
    start_date: '2025-01-01',
    status: 'active',
    termination_time_unit: 'months',
    type: 'recurring'
  },
  {
    _created_at: '2025-04-22T10:08:39.668Z',
    _id: '37cf1e00-d21f-4427-a1e0-d831d094b1cd',
    _org: 'test-org',
    _schema: 'contract',
    _tags: ['copy'],
    _title: 'Spark Professional Plus',
    _updated_at: '2025-05-20T06:15:02.202Z',
    account_number: 'C123456789',
    amount_subtotal: 912,
    amount_tax: 173,
    amount_total: 1085,
    balance: 0,
    balance_currency: 'EUR',
    balance_decimal: '0.00',
    billing_address: [MOCK_ADDRESS],
    billing_duration_amount: null,
    billing_duration_unit: 'months',
    billing_due_day: '1',
    billing_period: 'monthly',
    branch: 'power',
    contract_name: 'Spark Professional Plus',
    contract_number: '658901022',
    currency: 'EUR',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    end_date: '2025-12-31',
    installment_amount: 9900,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '99',
    move_in_date: '2025-01-01',
    notice_time_amount: '2',
    notice_time_unit: 'months',
    renewal_duration_unit: 'months',
    start_date: '2025-01-01',
    status: 'deactivated',
    termination_time_unit: 'months',
    type: 'recurring'
  },
  {
    _created_at: '2025-03-15T10:30:25.405Z',
    _id: '9c48b05d-bd9b-4699-bcdd-ef5f3e745a59',
    _org: 'test-org',
    _schema: 'contract',
    _tags: ['gas'],
    _title: 'Primary Gas',
    _updated_at: '2025-06-01T08:15:30.421Z',
    account_number: 'D123456789',
    amount_subtotal: 2500,
    amount_tax: 475,
    amount_total: 2975,
    balance: 150,
    balance_currency: 'EUR',
    balance_decimal: '1.50',
    billing_address: [MOCK_ADDRESS],
    billing_duration_amount: null,
    billing_duration_unit: 'months',
    billing_due_day: '15',
    billing_period: 'monthly',
    branch: 'gas',
    contract_name: 'Primary Gas',
    contract_number: '589010220',
    currency: 'EUR',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    end_date: null,
    installment_amount: 15000,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '150',
    move_in_date: '2025-03-01',
    notice_time_amount: '3',
    notice_time_unit: 'months',
    renewal_duration_unit: 'months',
    start_date: '2025-03-01',
    status: 'active',
    termination_time_unit: 'months',
    type: 'recurring'
  },
  {
    _created_at: '2025-02-10T14:22:18.305Z',
    _id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    _org: 'test-org',
    _schema: 'contract',
    _tags: ['water'],
    _title: 'Water Main',
    _updated_at: '2025-05-28T11:45:12.789Z',
    account_number: 'E123456789',
    amount_subtotal: 3200,
    amount_tax: 608,
    amount_total: 3808,
    balance: -200,
    balance_currency: 'EUR',
    balance_decimal: '-2.00',
    billing_address: [MOCK_ADDRESS],
    billing_duration_amount: null,
    billing_duration_unit: 'months',
    billing_due_day: '5',
    billing_period: 'quarterly',
    branch: 'water',
    contract_name: 'Water Main',
    contract_number: '589010221',
    currency: 'EUR',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    end_date: '2026-02-10',
    installment_amount: 25000,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '250',
    move_in_date: '2025-02-10',
    notice_time_amount: '6',
    notice_time_unit: 'months',
    renewal_duration_unit: 'months',
    start_date: '2025-02-10',
    status: 'active',
    termination_time_unit: 'months',
    type: 'recurring'
  },
  {
    _created_at: '2025-01-05T09:15:33.102Z',
    _id: 'f9e8d7c6-b5a4-9382-7160-fedcba098765',
    _org: 'test-org',
    _schema: 'contract',
    _tags: ['water'],
    _title: 'Dynamic Water Plan',
    _updated_at: '2025-06-10T16:30:45.234Z',
    account_number: 'F123456789',
    amount_subtotal: 800,
    amount_tax: 152,
    amount_total: 952,
    balance: 0,
    balance_currency: 'EUR',
    balance_decimal: '0.00',
    billing_address: [MOCK_ADDRESS],
    billing_duration_amount: 12,
    billing_duration_unit: 'months',
    billing_due_day: '28',
    billing_period: 'annually',
    branch: 'water',
    contract_name: 'Dynamic Water Plan',
    contract_number: '589010222',
    currency: 'EUR',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    end_date: null,
    installment_amount: 95200,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '952',
    move_in_date: '2025-01-05',
    notice_time_amount: '1',
    notice_time_unit: 'months',
    renewal_duration_unit: 'years',
    start_date: '2025-01-05',
    status: 'active',
    termination_time_unit: 'months',
    type: 'recurring'
  }
]
